import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css']
})
export class ToastComponent implements OnInit {
  @Output() onToastClose: EventEmitter<string> = new EventEmitter();
  @Input() toastMessage: string | SafeHtml | null | undefined;
  timeout = 3000;
  constructor() {
  }

  ngOnInit() {
    setTimeout(() => {
      this.onCloseClick();
    }, this.timeout);
  }

  onCloseClick(): void {
    this.onToastClose.emit();
  }

}
